import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-84823c80"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Apply Filters", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Clear Filters", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_ev_range_slider = _resolveComponent("ev-range-slider");
  const _component_variant_checkbox_group = _resolveComponent("variant-checkbox-group");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createBlock(_component_el_form, {
    class: "filter-box exo",
    "label-position": "top",
    autocomplete: "off"
  }, {
    default: _withCtx(() => [_ctx.title ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.title), 1)) : _createCommentVNode("", true), _ctx.allowTypeSelection ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 1,
      class: "type-group",
      label: "types"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.filters.types,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.filters.types = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productTypes, ptype => {
          return _openBlock(), _createBlock(_component_el_checkbox_button, {
            key: ptype.label,
            label: ptype.typeid
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(ptype.label), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.allowCountrySelection ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 2,
      label: "countries",
      "data-filter-kind": "countries"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        placeholder: "-- select one or more countries --",
        style: {
          "width": "100%"
        },
        modelValue: _ctx.filters.countryCodes,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.filters.countryCodes = $event),
        filterable: "",
        multiple: "",
        autocomplete: "off"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries.sort((a, b) => a.name > b.name ? 1 : -1), (country, c_idx) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: 'country' + c_idx,
            label: country.name,
            value: country.code
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "scale"
    }, {
      default: _withCtx(() => [_createVNode(_component_ev_range_slider, {
        modelValue: _ctx.filters.inverseScale,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.filters.inverseScale = $event),
        ticks: _ctx.scaleValues,
        minLabel: "No Limit",
        maxLabel: "No Limit"
      }, null, 8, ["modelValue", "ticks"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "date range"
    }, {
      default: _withCtx(() => [_createVNode(_component_ev_range_slider, {
        modelValue: _ctx.filters.year,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.filters.year = $event),
        ticks: _ctx.dateValues,
        minLabel: "Pre-1940",
        maxLabel: new Date().getFullYear().toString(),
        formatter: yr => yr.toString()
      }, null, 8, ["modelValue", "ticks", "maxLabel", "formatter"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "Available formats",
      class: "variants-group"
    }, {
      default: _withCtx(() => [_createVNode(_component_variant_checkbox_group, {
        active: _ctx.allVariants,
        primary: _ctx.allVariants,
        emphasize: _ctx.noneVariant,
        selection: _ctx.filters.variants,
        "onUpdate:selection": _cache[4] || (_cache[4] = $event => _ctx.filters.variants = $event)
      }, null, 8, ["active", "primary", "emphasize", "selection"])]),
      _: 1
    }), _ctx.allowPublisherSelection ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 3,
      label: "publishers"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        disabled: !(_ctx.publishers && _ctx.publishers.length > 0),
        placeholder: "-- all publishers --",
        modelValue: _ctx.filters.publishers,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.filters.publishers = $event),
        filterable: "",
        multiple: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishers, (pub, p_idx) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: 'pub' + p_idx,
            value: pub.permId,
            label: pub.name + ' - ' + pub.fullname
          }, null, 8, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "languages"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        disabled: !(_ctx.languages && _ctx.languages.length > 0),
        placeholder: "-- all languages --",
        modelValue: _ctx.filters.languages,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.filters.languages = $event),
        multiple: "",
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang, l_idx) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: 'lang' + l_idx,
            value: lang,
            label: lang
          }, null, 8, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "footer-item"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        id: "apply-filters",
        plain: "",
        disabled: !_ctx.changed,
        onClick: _ctx.applyFilter
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
        id: "clear-filters",
        plain: "",
        disabled: !_ctx.asNew,
        onClick: _ctx.resetFilter
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["disabled", "onClick"])]),
      _: 1
    })]),
    _: 1
  });
}